import { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { Form, Spin, Card, Tabs, Row, Col, Input, Button } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { apiCand } from "../../../../services/apiCand";
import { apiAuxiliar, obterCaracteristicasDiretor } from "../../../../services/apiAuxiliar";
import { getEntidadesLiberadasS3 } from "../../../../auth/entidadeUsuario";
import { maskCpf } from "../../../../utils/maskFunctions";
import "../style.css";

import { IMandatoCaracteristica, IMandatoHabilitacao, IDocumentoMandato, IMandatoFuncaoEspecial, ICaracteristicasMandato, IMandatoDirigente } from "../../Componentes/InterfaceMandato";
import { ICtrlDoc } from "../../../../Interfaces/DadosPrevicInterfaces";

import CadInfoBotoes from "../../Componentes/CadInfoBotoes";
import DiretorPerfil from "../Componentes/DiretorPerfil"
import DirigenteCaracteristica from "../../Componentes/DirigenteCaracteristica";
import DiretorFuncaoEspecial from "../Componentes/DiretorFuncaoEspecial";
import DirigenteHabilitacao from "../../Componentes/DirigenteHabilitacao";
import DirigenteDocumento from "../../Componentes/DirigenteDocumento";

import { resetColor } from "../../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../../utils/messages";

import { isStateWithoutDataValid, onlyNumbers } from "../../../../utils/utilsFunctions";

import { IErroApi } from "../../../../Interfaces/Interfaces";
import PessoaFisicaDadosPessoaisComplementares from "../../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import { useLocation } from "react-router";
import { IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import { CategoriasDirigente } from "../../../../config/Contantes";


const Cadastrar = (props: any) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();

  const [diretorRetPosCadastro, setDiretorRetPosCadastro] = useState<IMandatoDirigente>();

  const [mandatoCaracteristica, setMandatoCaracteristicas] = useState<IMandatoCaracteristica[]>([]);

  const [mandatoFuncoesEspeciais, setMandatoFuncoesEspeciais] = useState<IMandatoFuncaoEspecial[]>([]);

  const [mandatoHabilitacao, setMandatoHabilitacao] = useState<IMandatoHabilitacao[]>([]);

  const [mandatoDocumentos, setMandatoDocumentos] = useState<IDocumentoMandato[]>([]);

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [entidades, setEntidades] = useState<IEntidade[]>([]);


  useEffect(() => {
    if (isStateWithoutDataValid(state)) {
      form.setFieldsValue({
        "nuCpf": maskCpf(state.nuCpf),
        "nmPessoaFisica": state.nmPessoaFisica,
      });
    }

    const entidadeUsuario = getEntidadesLiberadasS3();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        "matriculaEfpc": entidadeUsuario[0].matricula,
        "sigla": entidadeUsuario[0].sigla,
      });
    }

    if (ctrlDoc.length === 0) getCtrlDocCons();
    if (caracteristicasMandato.length === 0) getCaracteristicasMandato();
  }, []);

  useEffect(() => {
    if (diretorRetPosCadastro) pushToManter(diretorRetPosCadastro);
  }, [diretorRetPosCadastro]);

  function pushToManter(diretor: IMandatoDirigente) {  // ABRE A TELA DE DETALHES DO DIRETOR

    let tpSelecao = {
      nuCpf: onlyNumbers(form?.getFieldValue("nuCpf")),
      nmPessoaFisica: form?.getFieldValue("nmPessoaFisica").toUpperCase(),
      matriculaEfpc: diretor.matriculaEfpc,
      sigla: form?.getFieldValue("sigla").toUpperCase(),
      manter: 2,
      data: diretor
    }
    navigate("/dirigente/diretor/manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [touched, setTouched] = useState(true);


  const validarDiretor = () => {
    // if (!verificaDatas()) {
    //   mostrarInfo("Campos inconsistentes", "A inclusão da data de cancelamento de certificadora exige também a inclusão de uma nova nota técnica");
    // }  else if (!validaDtReconhecimentoCertificadora(form?.getFieldValue("dtReconhecimento"), tipoCertificados)) {
    //   mostrarInfo("Erro na data de reconhecimento da certificadora", "A data de reconhecimento da certificadora não pode ser maior do que uma data de reconhecimento de certificado");
    // } else if (hasDocMandatory(certificadoraDocumentos) !== 1) {
    //   mostrarInfo("Erro em documentos", "Um e apenas um documento dentre 'ESTATUTO' e 'CONTRATO SOCIAL' deve ser incluído");
    //  } else {
    form
      .validateFields([
        "matriculaEfpc",
        "nmCargo",
        "dtInicioMandato",
        "dtFimMandato",
        "dtInicioExercicio",
        "dtFimExercicio",
      ])
      .then(() => {
        sendForm();
      })
      .catch((error) => {
        errorMessage("Campo obrigatório não preechido");
      });
    //  }
  };

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json: IMandatoDirigente = {
      idMandato: -1,
      idPessoaFisica: state.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      csCategoria: CategoriasDirigente["DIRETOR"].value, // Diretor Executivo
      nmCargo: form?.getFieldValue("nmCargo").toUpperCase(),
      dtInicioMandato: form?.getFieldValue("dtInicioMandato") ? dayjs(form?.getFieldValue("dtInicioMandato")).format("YYYY-MM-DD") : "",
      dtFimMandato: form?.getFieldValue("dtFimMandato") ? dayjs(form?.getFieldValue("dtFimMandato")).format("YYYY-MM-DD") : "",
      dtInicioExercicio: form?.getFieldValue("dtInicioExercicio") ? dayjs(form?.getFieldValue("dtInicioExercicio")).format("YYYY-MM-DD") : "",
      dtFimExercicio: form?.getFieldValue("dtFimExercicio") ? dayjs(form?.getFieldValue("dtFimExercicio")).format("YYYY-MM-DD") : "",
      csCondicaoMandato: 0, // Não se aplica para Diretor Executivo
      prorrogacao: false,
      reconducao: false,
      statusReg: 1,
      mandatoCaracteristicas: mandatoCaracteristica.map((e: IMandatoCaracteristica) => {
        return {
          ...e
        };
      }),
      mandatoFuncoesEspeciais: mandatoFuncoesEspeciais.map((e: IMandatoFuncaoEspecial) => {
        return {
          ...e
        };
      }),
      habilitacoes: mandatoHabilitacao.map((e: IMandatoHabilitacao) => {
        return {
          ...e
        };
      }),
      mandatoDocumentos: mandatoDocumentos.map((e: IDocumentoMandato) => {
        return {
          ...e
        };
      }),

    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.post(`/mandatodiretor`, json).then((response) => {
      setLoading(false);
      resetForm();

      successMessage(
        `Diretor ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) cadastrado com Sucesso`
      );

      setDiretorRetPosCadastro(response.data);
      // setManter(1)
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });


  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    setDiretorRetPosCadastro(undefined);
    setMandatoCaracteristicas([]);
    setMandatoFuncoesEspeciais([]);
    setMandatoHabilitacao([]);
    form.setFieldsValue({
      matriculaEfpc: undefined,
      nmCargo: undefined,
      dtInicioMandato: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };


  const [ctrlDoc, setCtrlDoc] = useState<ICtrlDoc[]>([]);
  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,entidade,cadastrar,diretor-executivo,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDoc(data.content);
  };

  const [caracteristicasMandato, setCaracteristicasMandato] = useState<ICaracteristicasMandato[]>([]);
  const getCaracteristicasMandato = async () => {
    const { data } = await obterCaracteristicasDiretor();
    setCaracteristicasMandato(data);
  }


  return (
    <>
      {/* <Prompt
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastrar Mandato de Diretor Executivo"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={validarDiretor}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item hidden={true} name="nuCpf"></Form.Item>
                  <Form.Item hidden={true} name="nmPessoaFisica"></Form.Item>

                  <Form.Item label="CPF" name="cpfDisabled">
                    <Input defaultValue={maskCpf(state.nuCpf)} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisicaDisabled">
                    <Input defaultValue={state.nmPessoaFisica} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} >
                  <Form.Item style={{ alignItems: 'center' }}
                    label="Detalhar Cadastro de Pessoa Física"
                  >
                    <Button
                      // style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                      // disabled={props.desabilitaBotoes()}
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>

              </Row>

            </Card>

            <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }}>
              <>
                <PessoaFisicaDadosPessoaisComplementares
                  form={form}
                  idPessoaFisica={state.idPessoaFisica}
                  mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                />
              </>
            </Row>

            <Card title={"Dados do Mandato"}>
              <>
                <DiretorPerfil
                  form={form}
                  entidades={entidades}
                  manter={manter}
                  dadosDirigente={undefined}
                />
              </>
            </Card>

            <Tabs>
              <Tabs.TabPane tab="Caracteristicas" key="item-1">
                <>
                  <DirigenteCaracteristica
                    form={form}
                    mandatoCaracteristica={mandatoCaracteristica}
                    setMandatoCaracteristica={setMandatoCaracteristicas}
                    caracteristicasMandato={caracteristicasMandato}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Funções Especiais" key="item-2">
                <>
                  <DiretorFuncaoEspecial
                    form={form}
                    mandatoFuncaoEspecial={mandatoFuncoesEspeciais}
                    setMandatoFuncaoEspecial={setMandatoFuncoesEspeciais}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Habilitação" key="item-3">
                <>
                  <DirigenteHabilitacao
                    form={form}
                    mandatoHabilitacao={mandatoHabilitacao}
                    setMandatoHabilitacao={setMandatoHabilitacao}
                    manter={manter}
                    tipoMandato={1}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Documentação" key="item-4">
                <>
                  <DirigenteDocumento
                    form={form}
                    dirigenteDocumento={mandatoDocumentos}
                    setDirigenteDocumento={setMandatoDocumentos}
                    ctrlDoc={ctrlDoc}
                    manter={manter}
                    csCategoria={1}
                  />
                </>
              </Tabs.TabPane>

            </Tabs>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              // desabilitaBtnEditar={true}
              // desabilitaBotoes={desabilitaBotoes}
              desabilitar={touched}
              setDesabilitar={setTouched}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;